import clsx from 'clsx'

export default function PrimaryButton({
  children,
  icon = null,
  type = 'button',
  disabled = false,
  loading = false,
  className = '',
}) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={clsx(
        'group flex h-14 w-full items-center justify-center gap-3 rounded-lg bg-gradient-to-br from-primary to-primary-container',
        'text-base font-bold text-on-primary transition-all active:scale-[0.985]',
        'disabled:cursor-not-allowed disabled:opacity-70',
        className
      )}
    >
      <span>{loading ? 'Please wait...' : children}</span>
      {icon ? (
        <span className="material-symbols-outlined text-[20px] transition-transform group-hover:translate-x-1">
          {icon}
        </span>
      ) : null}
    </button>
  )
}
